import { ofType } from 'redux-observable';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { deleteByIdFulfilled, DELETE_BY_ID, deleteError } from '../../actions/entity';
import * as api from '../../../utils/api';
import * as fromState from '../../reducers';
import { ENTITY_CONFIG } from '../../../utils/constants';
import { of } from 'rxjs';
import entityConfig from '../../../utils/entities';
import { takeUntilAppReset } from 'utils/helpers';

export default (action$, state$) => action$.pipe(
  ofType(DELETE_BY_ID),
  withLatestFrom(state$),
  mergeMap(([action, state]) =>
    api.deleteById({
      controller: entityConfig[action.entityType][ENTITY_CONFIG.API_PATH],
      id: action.payload.id,
      token: fromState.getUser(state).token
    }).pipe(
      takeUntilAppReset(action$),
      map(() => deleteByIdFulfilled(action.entityType, action.payload.id)),
      catchError((err, caught) => {
        if (err.status === 400) {
          return of(deleteError(action.entityType, err));
        }
        return api.onError(err, caught);
      })
    ))
);